import { useState } from "react";
import ListItem from "../TaskCreatorAndEditorSheet/ListItem/ListItem";
import ErrorAddOn from "../TaskCreatorAndEditorSheet/ListItem/ErrorAddOn/ErrorAddOn";
import { useTranslation } from "@coworker/locales";
import { MediaOrderedDetails } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { ConfirmSheetModal } from "@coworker/apprestructured/src/shared/components/ConfirmSheetModal/ConfirmSheetModal";
import { MediasQuantityContent } from "./MediasQuantityContent/MediasQuantityContent";
import { isLoading, Loading } from "../../loading";
import { MediasAndArticleCountResponse } from "@coworker/app/src/components/RoomSettings/types/media";

interface MediasQuantityProps {
  disabled?: boolean;
  isError?: boolean;
  mediasOrderedDetails: MediaOrderedDetails[] | null | Loading;
  mediasData: MediasAndArticleCountResponse[];
  handlePiecesChange: (
    mediaId: string,
    articleId: string,
    newPieces: number
  ) => void;
  handlePTagsChange: (
    mediaId: string,
    articleId: string,
    newPTags: number
  ) => void;
  handleConfirm: () => void;
}

export const MediasQuantity = ({
  disabled,
  isError,
  mediasOrderedDetails,
  mediasData,
  handlePiecesChange,
  handlePTagsChange,
  handleConfirm,
}: MediasQuantityProps) => {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const { t } = useTranslation();

  const handleConfirmWithClose = () => {
    handleConfirm();
    handleCloseModal();
  };

  if (isLoading(mediasOrderedDetails)) {
    return <div>Loading...</div>;
  }

  const totalPieces = Array.isArray(mediasOrderedDetails)
    ? mediasOrderedDetails.reduce((acc, media) => acc + media.pieces_ordered, 0)
    : 0;

  // Count unique medias (same mediaId can have multiple articles)
  const uniqueMediaCount = Array.isArray(mediasOrderedDetails)
    ? new Set(mediasOrderedDetails.map((media) => media.id)).size
    : 0;

  const description = t("piecesInDifferentMediaString", {
    pieces: totalPieces,
    count: uniqueMediaCount,
  });

  return (
    <>
      <ListItem
        testId="medias-quantity-list-item"
        title={t("getNewArticlesString")}
        onClick={handleOpenModal}
        emphasised={true}
        description={description}
        disabled={disabled}
        addOn={
          isError ? (
            <ErrorAddOn testId="medias-quantity-error">
              {t("pleaseFillInString")}
            </ErrorAddOn>
          ) : null
        }
      />
      <ConfirmSheetModal
        title={t("getNewArticlesString")}
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        handleConfirm={handleConfirmWithClose}
        content={
          <div>
            <MediasQuantityContent
              mediasOrderedDetails={mediasOrderedDetails}
              mediasData={mediasData}
              handlePiecesChange={handlePiecesChange}
              handlePTagsChange={handlePTagsChange}
            />
          </div>
        }
      />
    </>
  );
};
